var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFondoperfil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_73",
    "data-name": "Grupo 73",
    transform: "translate(-168 -65)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(168 65)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-2",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(186 65)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-3",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(204 65)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-4",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(222 65)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-5",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(240 65)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-6",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(258 65)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-7",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(276 65)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-8",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(168 83)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-9",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(186 83)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-10",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(204 83)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-11",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(222 83)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-12",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(240 83)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-13",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(258 83)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-14",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(276 83)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-15",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(168 101)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-16",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(186 101)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-17",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(204 101)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-18",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(222 101)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-19",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(240 101)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-20",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(258 101)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-21",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(276 101)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-22",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(168 119)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-23",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(186 119)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-24",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(204 119)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-25",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(222 119)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-26",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(240 119)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-27",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(258 119)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-28",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(276 119)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-29",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(168 137)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-30",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(186 137)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-31",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(204 137)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-32",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(222 137)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-33",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(240 137)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-34",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(258 137)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-35",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(276 137)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-36",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(168 155)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-37",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(186 155)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-38",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(204 155)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-39",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(222 155)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-40",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(240 155)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-41",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(258 155)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-42",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(276 155)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-43",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(168 173)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-44",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(186 173)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-45",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(204 173)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-46",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(222 173)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-47",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(240 173)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-48",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(258 173)",
    fill: "#FF6623"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-49",
    "data-name": "Elipse 9",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(276 173)",
    fill: "#FF6623"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoperfil);
export default __webpack_public_path__ + "static/media/fondoperfil.94da6556f3a69d3b6323518c5102abdf.svg";
export { ForwardRef as ReactComponent };